import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {reduxForm, getFormValues} from 'redux-form';
import {HttpStatusCode} from 'axios';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import withRouter from '../../../organisms/withRouter.js';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import PaperPart from '../../../atoms/PaperPart.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import {postRequest} from '../../../../common/backend.js';
import {createMessageLabel} from '../../../../common/common.js';
import {createDataMap} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import PageTitle from '../../../molecules/PageTitle.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import FooterButton from '../../../organisms/FooterButton.js';
// import {KAN_MIN_CATEGORY, RENKEI_CATEGORY} from '../../../../common/commonConst.js';
import {requiredCheck, lengthCheck} from '../../../../common/inputCheck.js';

const GET_DATA_URL = 'v1.0/bfa90202g/yoti/get';
const SEARCH_URL = 'v1.0/genericMst/search';

const footerBtnProps = [
  {type: 'positive', key: 'yotiBack', label: '閉じる', click: null, disabled: true},
];

const gridItems = {
  // {binding: 'moDasiUserId', header: '持出者', dataType: 'String', width: 150, readOnly: true},
  // {binding: 'moDasiYMD', header: '持出日時', dataType: 'String', width: 180, readOnly: true},
  // {binding: 'dataKizyoUserId', header: '解除者', dataType: 'String', width: 150, readOnly: true},
  // {binding: 'dataKizyoDate', header: '解除日時', dataType: 'String', width: 180, readOnly: true},
  MoDasiUserId: {binding: 'moDasiUserId', header: '持出者', dataType: 'String', width: 120, required: false},
  MoDasiDate: {binding: 'moDasiDate', header: '持出日時', dataType: 'String', width: 200, required: false},
  DataKizyoUserId: {binding: 'dataKizyoUserId', header: '解除者', dataType: 'String', width: 120, required: false},
  DataKizyoDate: {binding: 'dataKizyoDate', header: '解除日時', dataType: 'String', width: 200, required: false},
  // Timoku: {binding: 'timoku', header: '地目', dataType: 'String', dataMap: null, width: 120, required: true},
  // KantyoCd: {binding: 'kantyoCd', header: '管理者コード', dataType: 'String', maxLength: 4, width: 80, required: true},
  // Kantyo: {binding: 'kanrisya', header: '管理者', dataType: 'String', width: 160, isReadOnly: true, required: false},
  // DoroCd: {binding: 'doroCd', header: '道路コード', dataType: 'String', maxLength: 3, width: 70, required: true},
  // Doro: {binding: 'doro', header: '道路', dataType: 'String', width: 160, isReadOnly: true, required: false},
  // SetubiInfo: {binding: 'setubiInfo', header: '支持物施設場所', dataType: 'String', maxLength: 255, width: 241},
  MstKbn: {binding: 'mstKbn', header: ''},
  GridStatus: {binding: 'gridStatus', header: ''},
  Id: {binding: 'id', header: ''},
  supplyPointNo: {binding: 'supplyPointNo', header: ''},
  customerName: {binding: 'customerName', header: ''},
  UpdateTime: {binding: 'updateTime', header: ''},
};

/**
 * 用地情報ダイアログ
 *
 * 遷移元指定パラメータ
 * orderNo {string} 申込番号                    必須
 * rev {string} 版数                           必須
 * zigyojoCd {string} 事業場コード              必須
 * dntNo {string} 電柱番号                      必須
 * edaban {number} 枝番                         必須
 * senroNameNtt {string} 線路名
 * dntNoNtt {string} NTT電柱番号
 * editMode {bool} 編集可の場合、true
 * modalOpen {bool} モーダルの開閉状態            必須
 * closeButton {func} モーダルが閉じる際の処理    必須
 *
 */
class YotiInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warningMessages: null,
    };
    this.gridRef = React.createRef();
    this._gridItems = [];
    this._fields = [];
    this.initItems = {};
    this.setGridItems();
  }

  async componentDidMount() {
    this.initItems = {
      supplyPointNo: this.props.supplyPointNo,
      customerName: this.props.customerName,
      // zigyojoCd: this.props.zigyojoCd,
      // kanriKu: this.props.dntNo.slice(0, 3),
      // dntNo: this.props.dntNo,
      // edaban: this.props.edaban,
      // kanMinCategory: KAN_MIN_CATEGORY.KANTI,
    };
    if (this.gridRef.current) {
      this.gridRef.current.setItemsSource(null);
    }
    this.getInitializeData();
  }

  /**
   * 画面項目設定
   */
  setGridItems = () => {
    for (const key of Object.keys(gridItems)) {
      this._gridItems[key] = {...gridItems[key]};
      this._fields.push(this._gridItems[key].binding);
      if (Object.hasOwn(this._gridItems[key], 'dataMap')) {
        let map = this.getDataMap(this._gridItems[key]);
        this._gridItems[key].dataMap = map;
      }
    }
  };

  /**
   * 画面項目に合うデータマップを取得
   * @param {object} item 対象
   * @return {object} データマップ
   */
  getDataMap(item) {
    const key = Object.hasOwn(item, 'dataMapKey') ?
      item.dataMapKey : item.binding;
    // if (key === 'zigyojo') {
    //   return createZigyojoDataMap(this.props.zigyojo);
    // }
    return createDataMap(this.props.genericMap, key);
  }

  /**
   * データ取得
   */
  getData = async () => {
    const {supplyPointNo, customerName} = this.props;
    const body = {
      sourceGmnId: this.props.location.pathname.slice(1),
      orderNo: supplyPointNo,
      rev: customerName,

    };
    const response = await postRequest(GET_DATA_URL, body, this._fields);
    if (response.status != HttpStatusCode.Ok) {
      if (response.data.message != null) {
        this.props.doShowMessage({
          message: {id: response.data?.message.id,
            text: response.data?.message.text},
        });
      } else {
        this.props.doShowMessage({
          message: {id: 'BFY000016E'},
        });
      }
      return;
    }
    this.setYotiInfo(response.data.yotiInfoList);
  };

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let mdHistoryList = [];
    mdHistoryList = [
      {MoDasiUserId: '田中  一郎', MoDasiDate: '2026/12/19 00:00 23', DataKizyoUserId: '田中  一郎', DataKizyoDate: '2027/12/19 00:00 23'},
      {MoDasiUserId: '田中  一郎', MoDasiDate: '2026/12/19 00:00 23', DataKizyoUserId: '田中  一郎', DataKizyoDate: '2027/12/19 00:00 23'},
      {MoDasiUserId: '田中  一郎', MoDasiDate: '2026/12/19 00:00 23', DataKizyoUserId: '田中  一郎', DataKizyoDate: '2027/12/19 00:00 23'},
      {MoDasiUserId: '田中  一郎', MoDasiDate: '2026/12/19 00:00 23', DataKizyoUserId: '田中  一郎', DataKizyoDate: '2027/12/19 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/15 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/15 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/15 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/15 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/14 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/14 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/13 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/13 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/12 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/12 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/11 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/11 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/10 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/10 00:00 23'},

    ];

    this.setYotiInfo(mdHistoryList);
  };

  /**
   * 用地情報設定
   * @param {object} yotiInfoList
   */
  setYotiInfo = (yotiInfoList) => {
    if (this.gridRef.current) {
      const _warningMessages = this.getErrors(yotiInfoList);
      this.gridRef.current.setItemsSource(yotiInfoList);
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };


  /**
   * 戻る
   */
  doBack = () => {
    // 最初の行のデータを返却
    let data = {};
    if (this.gridRef.current && this.gridRef.current.grid &&
        this.gridRef.current.grid.rows && this.gridRef.current.grid.rows[0] &&
        this.gridRef.current.grid.rows[0]._data) {
      data = this.gridRef.current.grid.rows[0]._data;
    }
    this.props.closeButton(data);
  };

  /**
   * ボタン設定
   */
  setFooterButton = () => {
    const {handleSubmit} = this.props;
    for (const propsInfo of footerBtnProps) {
      if (propsInfo.key === 'yotiBack') { // 閉じる
        propsInfo.click = handleSubmit(this.doBack);
        propsInfo.disabled = false;
      }
    }
  };

  // /**
  //  * 行読み込み後の処理
  //  * @param {*} s
  //  * @param {*} e
  //  */
  // loadedRowsFunction = (s, e) => {
  //   for (const row of s.rows) {
  //     // 該当行を編集不可とする条件
  //     if (row._data.renkeiCategory === RENKEI_CATEGORY.BS) {
  //       row.isReadOnly = true;
  //       row.cssClass = 'bf-orange-background';
  //     }
  //   }
  // };

  /**
   * 一覧の入力チェック
   * @param {object} items 検証データ
   * @return {string} 結果
   */
  getErrors = (items) => {
    let _warning = [];
    let index = 1;
    for (const item of items) {
      for (const key of Object.keys(this._gridItems)) {
        const _binding = this._gridItems[key].binding;
        if (!_binding) {
          continue;
        }
        const result = this.getError(
            item, _binding, undefined,
            index, false);
        if (result) {
          _warning.push(result);
        }
      }
      index++;
    }
    return _warning;
  };

  /**
   * 一覧画面の入力チェック
   * @param {object} item 検証行データ
   * @param {string} prop binding
   * @param {boolean} parsing 予期されたデータ型に解析できない値を入力したかどうか
   * @param {string} rowIndex 行数
   * @param {boolean} convert メッセージに変換するかどうか
   * @return {string} 結果
   */
  getError = (item, prop, parsing, rowIndex=' ', convert=true) => {
    if (parsing) {
      return null;
    }

    const _gridItems = this._gridItems;

    const targets = Object.values(_gridItems)
        .filter((data) => data.binding == prop);
    const target = targets.length > 0 ? targets[0] : {};
    const label = createMessageLabel(target.groupHeader, target.header);
    let result =
      this._requiredCheck(target.required, label, item[prop], rowIndex);
    if (result.error) {
      return convert ?
          this.props.getMessage(result.message.id, result.message.values) :
          result.message;
    }
    result = this._lengthCheck(target.maxLength, label, item[prop], rowIndex);
    if (result.error) {
      return convert ?
          this.props.getMessage(result.message.id, result.message.values) :
          result.message;
    }
    return null;
  };

  /**
   * 必須チェック
   * @param {*} required
   * @param {*} header
   * @param {*} value
   * @param {*} rowIndex
   * @return {*} 結果
   */
  _requiredCheck = (required, header, value, rowIndex=' ') => {
    if (required) {
      return requiredCheck(header, value, rowIndex);
    }
    return {};
  };

  /**
   * 桁数チェック
   * @param {*} maxLength
   * @param {*} header
   * @param {*} value
   * @param {*} rowIndex
   * @return {*} 結果
   */
  _lengthCheck = (maxLength, header, value, rowIndex) => {
    if (maxLength && maxLength > 0) {
      return lengthCheck(header, value, maxLength, rowIndex);
    }
    return {};
  };

  /**
   * コード名称取得
   * @param {*} categoryType
   * @param {*} cd
   * @return {string} コード名称
   */
  searchGenericMst = async (categoryType, cd) => {
    const body = {
      categoryType: categoryType,
      valueString1: this.props.zigyojoCd,
      valueString2: cd,
    };
    const response = await postRequest(SEARCH_URL, body);
    if (response && response.data && response.data.length < 1) {
      this.props.doShowMessage({
        message: {
          id: 'BFY000033E',
          values: ['入力のコード（' + cd + '）',
            categoryType === 'kantyo_cd' ? '管理者コードマスタ' : '道路コードマスタ'],
        },
      });
    }
    return response && response.data && response.data[0] ?
        response.data[0].valueString3 :
        '';
  };

  /**
   * グリッド更新時処理
   * @param {*} s
   * @param {*} e
   */
  refreshedFunction = (s, e) => {
    if (!s._items) {
      return;
    }
    const items = s._items._view;
    const _warningMessages = this.getErrors(items);
    this.setState({
      warningMessages: _warningMessages,
    });
  };

  /**
   * 一覧描画
   * @return {*}
   */
  renderTable = () => {
    const isDisabled = !this.props.editMode;
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      exceptFilters: [],
      allowSorting: 'None',
      style: {maxHeight: '300pt'},
      isReadOnly: isDisabled,
      validateEdits: false,
      trackChanges: true,
      screenId: 'YotiInfo',
      initItems: this.initItems,
      maxRowSize: 20,
      getError: this.getError,
      // loadedRowsFunction: this.loadedRowsFunction,
      cellEditEndedFunction: this.cellEditEndedFunction,
      refreshedFunction: this.refreshedFunction,
    };
    const component = createComponents(this._gridItems, isDisabled);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  };

  render() {
    const {supplyPointNo, customerName,
    } = this.props;
    this.setFooterButton();
    // let zigyojoName = '';
    // for (const data of zigyojo) {
    //   if (data.zigyojoCd === zigyojoCd) {
    //     zigyojoName = data.zigyojoName;
    //     break;
    //   }
    // }
    const header = '供給地点特定番号：' + (supplyPointNo ? supplyPointNo: ' ') + '　お客さま名：' + (customerName ? customerName : ' ');
    return (
      <Modal
        open={this.props.modalOpen}
        style={{
          maxWidth: 1000,
          marginLeft: 'auto',
          marginRight: 'auto',
          overflow: 'visible',
        }}
        disableEnforceFocus={true}
      >
        <form noValidate autoComplete="off" style={{maxHeight: '100vh'}} >
          <PaperPart style={{maxHeight: '90vh'}}>
            <PageTitle pageTitle={'データ持出履歴'}/>
            <Grid key="keyYotiInfoHeader" item xs={12}>
              <Typography variant="h6" gutterBottom>{header}</Typography>
            </Grid>
            <Grid key="keyYotiInfoMsg" item xs={12}>
              <WarningMessageArea messages={this.state.warningMessages}/>
            </Grid>
            <Grid key="keyYotiInfoArea" item xs={12}>
              {this.renderTable()}
            </Grid>
            <Grid key="keyYotiInfoFooter" item xs={12}>
              <FooterButton components={footerBtnProps} _props={this.props}/>
            </Grid>
          </PaperPart>
        </form>
      </Modal>
    );
  }
};

YotiInfo.propTypes={
  location: PropTypes.object,
  handleSubmit: PropTypes.func,
  values: PropTypes.object,
  reset: PropTypes.func,
  genericMap: PropTypes.object,
  zigyojo: PropTypes.array,
  doShowMessage: PropTypes.func,
  getMessage: PropTypes.func,
  // 呼び出し元設定
  supplyPointNo: PropTypes.string.isRequired,
  customerName: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  modalOpen: PropTypes.bool.isRequired,
  closeButton: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    genericMap: state.common.generalPurposeMap,
    zigyojo: state.common.zigyojo,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
};

const FORM_NAME = 'YotiInfo';

YotiInfo = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(YotiInfo));

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withFormatMessage(withMediaQuery()(YotiInfo))));
